// extracted by mini-css-extract-plugin
export default {"wrap":"invside_wrap__qK00x","icons":"invside_icons__EnBvR","flex":"invside_flex__6TlVD","left":"invside_left__sscx6","right":"invside_right__TaRaa","active":"invside_active__DOZ6S"};